import clsx from 'clsx'
import React from 'react'
import Box from '@mui/material/Box'
import {makeStyles} from 'external/material'

const caret = '<img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAABhGlDQ1BJQ0MgcHJvZmlsZQAAKJF9kT1Iw0AcxV9TpSoVQTsUccjQOlkQFXHUKhShQqgVWnUwufQLmjQkKS6OgmvBwY/FqoOLs64OroIg+AHi5Oik6CIl/i8ptIj14Lgf7+497t4BQr3MNKtrHNB020wl4mImuyoGXtGLMAYRRURmljEnSUl0HF/38PH1LsazOp/7c/SrOYsBPpF4lhmmTbxBPL1pG5z3iUOsKKvE58RjJl2Q+JHrisdvnAsuCzwzZKZT88QhYrHQxkobs6KpEU8RR1RNp3wh47HKeYuzVq6y5j35C4M5fWWZ6zRHkMAiliBBhIIqSijDRoxWnRQLKdqPd/APu36JXAq5SmDkWEAFGmTXD/4Hv7u18pMTXlIwDnS/OM5HFAjsAo2a43wfO07jBPA/A1d6y1+pAzOfpNdaWuQIGNgGLq5bmrIHXO4A4SdDNmVX8tMU8nng/Yy+KQsM3QJ9a15vzX2cPgBp6ip5AxwcAqMFyl7v8O6e9t7+PdPs7wegFXK5XwEHOwAAAAlwSFlzAAAN1wAADdcBQiibeAAAAAd0SU1FB+QJGBMJOUkbwF0AAABQSURBVEjHY2AYBaNgFAx9wEhA3oGBgcGLgJrdUIwVMBPQ/ICBgeE3AwODKjmGE2MBPksIGk6sBdgsIcpwUiyAWcLAwMBwj1jDR8EoGAV0AgCKXg7pFIpDaAAAAABJRU5ErkJggg==" style="width: 24px;">';

const useStyles = makeStyles(selectStyles)

export default function Select (props) {

  const classes = useStyles()
  return (
    <Box className={clsx(props.className, classes.root)}>
      <Box className={classes.value}>{props.value}</Box>
      <Box className={classes.caret} dangerouslySetInnerHTML={{__html: caret}} />
    </Box>
  )
}

function selectStyles(theme) {
  return {
    root: {
      display: 'flex',
      padding: '9px 0px 9px 9px',
      border: 'solid 1px #e0e5e9',
      borderRadius: 3,
      '& > div': {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center'
      }
    },
    value: {
      justifyContent: 'center',
      flexGrow: 1
    },
    caret: {
      flexShrink: 0
    }
  }
}



